import sendClarityEvent from "utils/clarity"
import { sendHotjarEvent } from "utils/hotjar"
import SESSION_RECORDING_EVENTS from "utils/session-recording-events"

export { SESSION_RECORDING_EVENTS }

export function sendSessionRecordingEvent(eventName) {
  sendHotjarEvent(eventName)
  sendClarityEvent(eventName)
}
